import { Resource } from 'i18next';
import { locale as enUs } from 'translations/locales/en_us';
import { locale as frCa } from 'translations/locales/fr_ca';

export const resources: Resource = {
  'en-US': enUs,
  'fr-CA': frCa,
};
